import React from 'react';

const AboutPage: React.FC = () => {
    return (
        <div className="max-w-6xl mx-auto px-4 py-12 md:py-24">
            <div className="mb-16">
                <h1 className="text-4xl md:text-5xl font-bold mb-12 tracking-tighter">
                    About <span className="text-accent" style={{
                        color: '#3F013D',
                        textShadow: '1px 1px 0 #ae4094, -1px -1px 0 #000, 0px 1px 0 #ae4094, 1px 0px 0 #ae4094, 0px -1px 0 #000, -1px 0px 0 #000'
                    }}>Samsara</span>
                </h1>

                <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl">
                    Samsara Capital Partners is the investment arm of <a href="https://pshg.co/" className="text-accent-light hover:underline" target="_blank" rel="noopener noreferrer">Polymath Solutions Holding Group</a>. We focus on investing in and enabling the transition toward agentic, AI-driven operations that empower businesses to achieve greater efficiency, speed, and adaptability. Our strategy combines multidimensional private equity, tech-enabled services rollups, and multistage venture capital to build a virtuous, reinforcing competitive position. <br /><br />
                    We specialize in acquiring and integrating both service businesses and software platforms. By leveraging AI, automation, and operational excellence, we create compounding, cross-vertical ecosystems that align incentives and reward stakeholder teams for driving transformative improvements and capturing outsized value at every level.
                </p>
           

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
                    <div>
                        <h2 className="text-2xl font-bold mb-4">Our Approach</h2>
                        <p className="text-gray-300 mb-4">
                            Unlike traditional rollups, our approach fuses software, AI, and services into unified
                            operating platforms. We source and acquire where proper seller-financed controlling interests in 10-15% margin businesses and expand them to 30-40% ebitda margin, consolidate costs and operations, increase throuput, nurture retention loops, and build playbooks of repeatability. We do this by deployinging AI across the stack creating multiplicative value across various levers, hence leading to increase of revenues; Integrating orquestration and agency hand off across swarms of agents, agentic tools and shared workflows from scheduling and billing to analytics and onboarding.
                            Transforming the business into a cross-vertical synergistic tech-enabled ecosystem that can scale and compound. We target 2-3yr rollups across our fund life, with a 6x equity MOIC in 5yrs. By assigning a portion of our investment allocation into proprietary tools and software, used by our rolled entity of businesses, we capture value through both the acquisition itself and the convertible licensing of these technologies.
                            
                        </p>
                        <p className="text-gray-300">
                            By pairing operating businesses with proprietary tools, data systems, and go-to-market
                            engines, we create compounding efficiency, shared IP, and attractive exit pathways.
                        </p>
                    </div>

                    <div className="bg-gray-900 bg-opacity-50 p-8 rounded-lg">
                        <h2 className="text-2xl font-bold mb-4">Our Values</h2>
                        <ul className="space-y-3 text-gray-300">
                            <li className="flex items-start">
                                <span className="text-[#ff00c3] mr-2">■</span>
                                <span><strong>Compounding Through Integration</strong>: We build systems that scale across time and verticals.</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#ff00c3] mr-2">■</span>
                                <span><strong>AI as Infrastructure</strong>: Not just tools, but foundations for margin, throughput, and insight.</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#ff00c3] mr-2">■</span>
                                <span><strong>Radical Clarity & Partnership</strong>: We collaborate deeply with founders, operators, and product leaders.</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#ff00c3] mr-2">■</span>
                                <span><strong>Uncovering Non-Obvious Value</strong>: We seek sectors and businesses overlooked by traditional PE.</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#ff00c3] mr-2">■</span>
                                <span><strong>Execution is Leverage</strong>: Operating discipline unlocks opportunity others miss.</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="mt-20">
                <h2 className="text-3xl font-bold mb-8">Contact Us</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div>
                        <p className="text-xl text-gray-300 mb-6">
                            Interested in learning more about our approach or exploring potential partnerships?
                            We'd love to hear from you.
                        </p>
                    </div>

                    <div className="bg-accent bg-opacity-20 p-6 rounded-lg">
                        <p className="font-medium">Samsara Capital Partners</p>
                        {/* <p className="text-gray-400">1234 Innovation Drive</p> */}
                        <p className="text-gray-400">Berkeley, CA</p>
                        <p className="mt-4"><span className="text-gray-400">Email:</span> info@samsarainc.com</p>
                        {/* <p><span className="text-gray-400">Phone:</span> +1 (415) 555-0123</p> */}
                    </div>

                    {/* <div className="bg-gray-900 p-6 rounded-lg">
                        <form className="space-y-4">
                            <div>
                                <label className="block text-gray-300 mb-2">Name</label>
                                <input
                                    type="text"
                                    className="w-full p-3 bg-black border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-300 mb-2">Email</label>
                                <input
                                    type="email"
                                    className="w-full p-3 bg-black border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-300 mb-2">Message</label>
                                <textarea
                                    rows={4}
                                    className="w-full p-3 bg-black border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent"
                                ></textarea>
                            </div>
                            <button
                                type="submit"
                                className="px-6 py-3 bg-accent text-white font-medium rounded-lg hover:bg-opacity-90 transition-colors"
                            >
                                Send Message
                            </button>
                        </form>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default AboutPage; 